import { For as ChakraFor } from '@chakra-ui/react'

export const For = ChakraFor
